<script>
import { http } from '@/system/http.js';
import hasSelectedProducts from '@/online_booking/new/mixins/hasSelectedProducts.js';
import Card from '@/online_booking/new/components/common/Card';
import { mapActions, mapState, mapGetters } from 'vuex';
import PreviousButton from '@/online_booking/new/components/common/PreviousButton';
import StepCounter from "@/online_booking/new/components/common/StepCounter";

export default {
    mixins: [hasSelectedProducts],

    data() {
        return {
            visible: false,
            first_step: null,
            loading: false,
            permalink: null,
            publishable_key: Config.get('app.STRIPE_PUBLISHABLE_KEY'),
            dataFrm: null,
            calendar: null,
            time: null,
            user: null,
            payment_error: '',
            voucher: null,
            payment_rate_request: 0,
            stripe : false,
            stripe_card : false,
            stripe_payment_intent_secret : false,
            giftcard_being_purchased: null,
            logged_in_client: null,
            email_to_receive_receipt: '',
            discount_being_used: null,
            amount_discounted: 0,
        };
    },

    mounted() {

        this.$event_bus.$on('LoadData', (data) => {
            this.permalink = data.permalink;
            this.first_step = data.online_booking_settings.first_step;
            this.user = data.user;
            this.logged_in_client = data.logged_in_client;
        });

        this.$event_bus.$on('voucherClicked', (voucher) => {
            this.voucher = voucher;
            if (this.voucher.price > 0) {
                this.visible = true;
            }
        });

        this.$event_bus.$on('payment', (data) => {
            this.dataFrm = data.dataFrm;
            this.stripe_payment_intent_secret = data.data.payment_intent_secret;
            this.calendar = data.data && data.data.markup ? data.data.markup.calendar : null;
            this.payment_rate_request = data.data.payment_rate_request;
            this.triggerStateChange();
            window.location.hash = 'payment';
        });

        this.$event_bus.$on('ShowGiftcardPayment', (giftcard, data) => {
            this.giftcard_being_purchased = giftcard;
            this.discount_being_used = data.discount,
                this.stripe_payment_intent_secret = data.payment_intent.client_secret;

            this.dataFrm = new FormData();

            if (this.discount_being_used) {
                this.amount_discounted = data.amount_discounted / 100;
                this.dataFrm.append('discount_code', data.discount.code);
                this.dataFrm.append('discount_code_id', data.discount.id);
            }

            this.dataFrm.append('giftcard_name', giftcard.name);
            this.dataFrm.append('giftcard_price', data.giftcard_price);
            this.dataFrm.append('payment_intent_id', data.payment_intent.id);
            this.dataFrm.append('amount', data.payment_intent.amount / 100);
            this.dataFrm.append('currency', data.payment_intent ? data.payment_intent.currency.toUpperCase() : '');
            this.dataFrm.append('name', data.data.name);
            this.dataFrm.append('email', data.data.email);
            this.dataFrm.append('address', data.data.address);
            this.dataFrm.append('address_line_2', data.data.address_line_2);
            this.dataFrm.append('zip', data.data.zip);
            this.dataFrm.append('city', data.data.city);
            this.dataFrm.append('zone', data.data.zone);
            this.dataFrm.append('country', data.data.country);
            this.dataFrm.append('design', giftcard.design);
            this.dataFrm.append('text_color', giftcard.text_color);

            if (giftcard.background_image) {
                this.dataFrm.append('background_image', giftcard.background_image);
            }

            this.triggerStateChange();

            this.email_to_receive_receipt = data.data.email;
        });

        this.$event_bus.$on('clientUpdated', client => {
            this.logged_in_client = client;
        });

        this.$event_bus.$on('timeSet', (time, fullyBooked, isOnWaitingList) => {
            this.time = time;

            if (isOnWaitingList) {
                this.visible = false;
            }
        });

        this.$event_bus.$on('preferredTimeSet', (selected_time, fullDaySignup, comments, fullyBooked, waitingList) => {
            this.time = selected_time;

            if (waitingList) {
                this.visible = false;
            }
        });


        this.$event_bus.$on('VouchersShowed', () => {
            this.visible = false;
        });

        this.$event_bus.$on('GiftcardsShowed', () => {
            this.visible = true;
        });

        $(document).ready(function(){
            $('[data-toggle="tooltip"]').tooltip();
        });

        if (typeof Stripe !== 'undefined') {
            this.stripe = Stripe(this.publishable_key, { locale: moment_locale });

            var style = {
                base: {
                    // Add your base input styles here. For example:
                    fontSize: '16px',
                    color: "#505458",
                }
            };

            this.stripe_card = this.stripe.elements().create('card', {style: style});
            this.stripe_card.mount('#card-element');
        }


    },

    methods: {
        ...mapActions('OnlineBooking', ['setCurrentStep', 'setPaymentStepVisibility']),

        pay() {
            this.loading = true;
            this.stripe.handleCardPayment( this.stripe_payment_intent_secret, this.stripe_card, {} ).then( (response) => this.stripeResponseHandler(response) );
        },

        stripeResponseHandler(response) {

            this.payment_error = '';

            if (response.error) {
                this.payment_error = this.getStripeErrorMessage(response.error.message, response.error.code);
                this.loading = false;
            } else {
                this.payBooking(response.paymentIntent);
            }
        },


        payBooking(payment_intent) {
            this.dataFrm.append('payment_intent_id', payment_intent.id);
            this.dataFrm.append('payment_intent_payment_method', payment_intent.payment_method);

            var url;
            if (this.giftcard_being_purchased) {
                url = '/giftcards/' + this.permalink + '/pay';
            } else if (this.voucher) {
                url = '/voucher/' + this.voucher.id + '/pay';
            } else {
                url = '/book/' + this.permalink + '/pay-booking';
            }

            http.post(url, this.dataFrm)
                .then(({ data }) => {
                    this.$event_bus.$emit('finish', data);
                    this.loading = false;
                })
                .catch((error) => {
                    let { errorBag } = error;
                    this.loading = false;
                    this.$setErrorBag(errorBag);
                });
        },

        getStripeErrorMessage(message, code) {

            if (code == "invalid_expiry_month" || code == "invalid_expiry_year") {
                return trans('online_payment.card_date_error');
            }

            if (code == "incorrect_number" || code == 'invalid_number') {
                return trans('online_payment.card_number_error');
            }

            if (code == 'invalid_cvc' || code == 'incorrect_cvc') {
                return trans('online_payment.card_cvc_error');
            }

            if (code == 'expired_card') {
                return trans('online_payment.card_expired');
            }

            if (code == 'card_declined') {
                return trans('online_payment.card_declined');
            }

            if (code == 'processing_error' || code == 'rate_limit') {
                return trans('online_payment.card_error');
            }

            if ('newrelic' in window) {
                window.newrelic.noticeError('Unhandled Stripe error: ' + code + ' - ' + message);
            }

            return message;

        },

        getTimeFormatted(time) {
            return moment(time.date).locale(moment_locale).format('LLL');
        },

        triggerStateChange() {
            this.setCurrentStep('payment');
        },
    },

    computed: {
        ...mapState('OnlineBooking', ['currentStep']),
        ...mapGetters('OnlineBooking', ['getPreviousStepId', 'currentStepNumber', 'totalStepCount']),

        shouldReservePayment() {
            return this.reservableProducts.length > 0;
        },

        giftcardPriceToPay() {
            if (this.giftcard_being_purchased && this.dataFrm.get('amount')) {
                return this.dataFrm.get('currency') + ' ' + parseFloat(this.dataFrm.get('amount')).toFixed(2);
            }

            return '';
        },

        amountDiscounted() {
            if (this.discount_being_used && this.amount_discounted) {
                return '- ' + this.dataFrm.get('currency') + ' ' +
                    parseFloat(this.amount_discounted).toFixed(2) +
                    ' (' + this.discount_being_used.code +
                    (this.discount_being_used.type == 'percentage' ? ' ' + this.discount_being_used.value + '%' : '') +
                    ')';
            }

            return '';
        },

        isPaymentStepActive () {
            return this.currentStep === 'payment';
        },

    },

    watch: {
        totalPriceToPayNow(priceToPay) {
            if (priceToPay > 0) {
                this.visible = true;
            } else {
                this.visible = false;
            }
        },

        visible (newValue) {
            this.setPaymentStepVisibility(newValue);
        },
    },

    components: {
        StepCounter,
        Card,
        PreviousButton,
    }
};
</script>


<template id="payment">
    <div class="payment-container" v-show="visible && isPaymentStepActive">
        <card class="p-0 overflow-hidden rounded-lg" id="payment-panel">
            <h4 class="section-title">
                <step-counter :current="currentStepNumber" :total="totalStepCount" />
                {{ trans('online_payment.payment_heading') }}
            </h4>
            <div
                id="collapsePayment"
                role="tabpanel"
                aria-labelledby="headingClients"
                data-parent="#booking-accordion"
            >
                <div class="panel-body" id="choose-user-body-booking">
                    <div class="row">
                        <div class="col-xs-12">
                            <ep-banner class="mb-6" v-if="payment_rate_request || shouldReservePayment">
                                <span v-if="payment_rate_request">{{ trans('online_payment.payment_rates_request_info') }}</span>
                                <span v-else-if="shouldReservePayment">{{ trans('online_payment.payment_reservation_required') }}</span>
                            </ep-banner>

                            <ep-banner class="mb-6" v-if="giftcard_being_purchased" v-sanitize-html="trans('giftcards.purchasing.email_receipt_info', { email: email_to_receive_receipt })"></ep-banner>

                            <ep-banner variant="danger" class="mb-6" v-if="payment_error">
                                <i class="zmdi zmdi-alert-triangle m-r-10 alert-ico"></i>
                                <span>{{ payment_error }}</span>
                            </ep-banner>

                            <div class="flex flex-column sm:flex-col-reverse space-y-6 sm:space-y-reverse">
                                <div class="well shadow-none mb-0">

                                    <form v-on:submit.prevent="pay" id="payment-frm" class="form-horizontal" role="form">

                                        <div class="row">
                                            <div class="col-xs-12">
                                                <div id="card-element" class="card-box"></div>
                                            </div>
                                        </div>

                                        <button class="btn btn-block btn-lg btn-custom collapsed" type="submit" v-if="!loading" id="card-button" :data-secret="stripe_payment_intent_secret">
                                            <i class="zmdi zmdi-check"></i>
                                            <span class="m-l-10">
                                                {{ trans('online_payment.submit') }}
                                                <span v-if="giftcard_being_purchased">{{ giftcardPriceToPay }}</span>
                                                <span v-else>{{ payment_rate_request ? totalProductsRatePriceFormatted : totalPriceToPayNowFormatted }}</span>
                                            </span>
                                        </button>

                                        <div class="btn btn-block btn-lg btn-custom btn-payment-loading" v-if="loading">
                                            <div class="preloader"></div>
                                        </div>

                                        <p class="text-center secure-payment m-t-5">
                                            <small>
                                                <span class="zmdi zmdi-lock m-r-5" aria-hidden="true"></span>
                                                {{ trans('online_payment.secure_payments_new') }} <a :href="trans('online_payment.easypay_website_url')"
                                                                                                     target="_blank">EasyPay</a> {{ trans('global.and') }} <a
                                                href="https://stripe.com" target="_blank">Stripe</a>
                                            </small>
                                        </p>

                                    </form>
                                </div>
                                <div class="payment-box">
                                    <form class="form-horizontal" role="form">
                                        <h5 class="m-t-0" v-if="voucher || giftcard_being_purchased">{{ trans('vouchers.purchase_confirmation.subtitle') }}</h5>
                                        <h5 class="m-t-0" v-else>{{ trans('online_payment.online_booking_payment_heading_booking') }}</h5>

                                        <hr>

                                        <div class="form-group row" v-if="hasSelectedProducts">
                                            <label class="col-sm-4 control-label mb-0">{{ trans('invoice.orderline_total_price') }}</label>
                                            <div class="col-sm-8">
                                                <div class="form-control-static">
                                                    <strike v-if="finalPrice < totalPrice">{{ totalPriceFormatted }}</strike>
                                                    <span v-else>{{ totalPriceFormatted }}</span>
                                                    <span v-if="finalPrice < totalPrice" class="ml-3">{{ finalPriceFormatted }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group row text-success" v-if="hasSelectedProducts && totalPriceToPayNow !== totalPrice">
                                            <label class="col-sm-4 control-label mb-0">{{ trans('online_booking.to_pay_now') }}</label>
                                            <div class="col-sm-8">
                                                <div class="form-control-static">
                                                    <span v-if="payment_rate_request">{{ totalProductsRatePriceFormatted }}</span>
                                                    <span v-else>{{ totalPriceToPayNowFormatted }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group row" v-if="time">
                                            <label class="col-sm-4 control-label mb-0">{{ trans('online_booking.receipt_time') }}</label>
                                            <div class="col-sm-8">
                                                <div class="form-control-static">{{ getTimeFormatted(time) }}</div>
                                            </div>
                                        </div>

                                        <div class="form-group row" v-if="hasSelectedProducts && !voucher">
                                            <label class="col-sm-4 control-label mb-0" v-text="selectedProducts.length > 1 ? trans('global.products') : trans('global.product')"></label>
                                            <div class="col-sm-8 form-control-static">
                                                <div v-for="(product, index) in selectedProducts" :key="index">{{ product.name }}</div>
                                            </div>
                                        </div>

                                        <div class="form-group row" v-if="selectedAddonProducts.length && !voucher">
                                            <label class="col-sm-4 control-label mb-0" v-text="selectedAddonProducts.length > 1 ? trans('online_booking.addon_products') : trans('online_booking.addon_product')"></label>
                                            <div class="col-sm-8 form-control-static">
                                                <div v-for="(addon, index) in selectedAddonProducts" :key="index">{{ addon.name }}</div>
                                            </div>
                                        </div>

                                        <template v-if="giftcard_being_purchased">
                                            <div class="form-group row">
                                                <label class="col-sm-6 control-label mb-0">{{ trans('giftcards.name_label') }}</label>
                                                <div class="col-sm-6">
                                                    <div class="form-control-static">
                                                        <span>{{ giftcard_being_purchased.name }}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group row" v-if="discount_being_used">
                                                <label class="col-sm-6 control-label mb-0">{{ trans('global.discount') }}</label>
                                                <div class="col-sm-6">
                                                    <div class="form-control-static">
                                                    <span>
                                                        {{ amountDiscounted }}
                                                    </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-sm-6 control-label mb-0">{{ trans('giftcards.list_amount') }}</label>
                                                <div class="col-sm-6">
                                                    <div class="form-control-static">
                                                        <span>{{ giftcardPriceToPay }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>

                                        <template v-if="voucher">
                                            <div class="form-group row">
                                                <label class="col-sm-4 control-label mb-0">{{ trans('vouchers.title') }}</label>
                                                <div class="col-sm-8">
                                                    <div class="form-control-static">{{ voucher.name }}</div>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-sm-4 control-label mb-0">{{ trans('settings.amount') }}</label>
                                                <div class="col-sm-8">
                                                    <div class="form-control-static" v-if="payment_rate_request">{{ voucher.rate_price_including_vat_formatted }}</div>
                                                    <div class="form-control-static" v-else>{{ voucher.price_including_vat_formatted }}</div>
                                                </div>
                                            </div>

                                            <div class="form-group row" v-if="voucher.product">
                                                <label class="col-sm-4 control-label mb-0">{{ trans('global.product') }}</label>
                                                <div class="col-sm-8">
                                                    <div class="form-control-static">{{ voucher.product.name }}</div>
                                                </div>
                                            </div>

                                            <div class="form-group row" v-if="voucher.expiry_days">
                                                <label class="col-sm-4 control-label mb-0">{{ trans('client.expiry_date') }}</label>
                                                <div class="col-sm-8">
                                                    <div class="form-control-static">{{ trans('vouchers.expires_after', { days : voucher.expiry_days }) }}</div>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-sm-4 control-label mb-0">{{ trans('vouchers.number_of_uses') }}</label>
                                                <div class="col-sm-8">
                                                    <div class="form-control-static">{{ voucher.clips }}</div>
                                                </div>
                                            </div>
                                        </template>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <previous-button class="p-6 pt-0" :previous-step-id="getPreviousStepId" />
        </card>
    </div>
</template>

<style>
.payment-cards img {
    width: 50px;
    height: auto;
    margin-right: 10px;
}
</style>
